import { useEffect, useState, useMemo } from 'react';
import { SupportedChainId } from '@orionprotocol/sdk';
import { isSupportedChainId } from '@orionprotocol/utils';

import { useAvailableNetworks } from './useAvailableNetworks';

const LOCATION_NETWORK_KEY_HASH: Record<string, string> = {
  '/governance': 'isGovernanceAvailable',
  '/swap': 'isSwapAvailable',
}

interface PageAvailableNetworks {
  pageAvailableNetworks: ReturnType<typeof useAvailableNetworks>;
  supportedChainIds: SupportedChainId[];
}

export const usePageAvailableNetworks = (): PageAvailableNetworks => {
  const availableNetworks = useAvailableNetworks();
  const [filteredNetworks, setFilteredAvailableNetworks] = useState<typeof availableNetworks>({});
  const currentLocation = window.location.pathname;

  useEffect(() => {
    setFilteredAvailableNetworks(
      Object.entries(availableNetworks)
        .reduce((acc, [key, network]) => {
          const availabilityKey = LOCATION_NETWORK_KEY_HASH[currentLocation];
          // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
          if (availabilityKey !== undefined && network[availabilityKey as keyof typeof network] === false) {
            return acc;
          }

          return ({
            ...acc,
            [key]: network
          });
        }, {})
    )
  }, [availableNetworks, currentLocation]);

  const supportedChainIds = useMemo(() => Object.keys(filteredNetworks).reduce((acc, id) => {
    if (isSupportedChainId(id)) {
      acc.push(id);
    }
    return acc;
  }, []), [filteredNetworks]);

  return ({
    pageAvailableNetworks: filteredNetworks,
    supportedChainIds
  });
};
